import { Component, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { environment } from 'src/environments/environment';
import { StorageService } from './services/storage.service';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { AuthService } from './services/guard/auth.service';
import { MenuVisibilityService } from './services/menu-visibility.service';
import { ErrorService } from './services/error.service';
import { ThemeService } from './services/theme.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit {

  showMenu = false;
  // Menu visibility handled by MenuVisibilityService

  errorMessage: string | null = null;
  errorCode: string | null = null;
  errorLogId: string | null = null;

  constructor(
    private platform: Platform,
    private storageService: StorageService,
    private router: Router,
    private authService: AuthService,
    private errorService: ErrorService,
    private menuVisibility: MenuVisibilityService,
    private themeService: ThemeService
  ) { }

  /** On init */
  ngOnInit(): void {
    // Apply browser-default theme immediately so the page renders correctly before auth resolves.
    this.themeService.applyDefault();

    // Re-apply once the user loads in case they have a saved preference.
    this.authService.user$.subscribe((user) => {
      if (user) {
        this.themeService.apply((user as any).preferredTheme ?? 'system');
      }
    });

    this.platform.ready().then(async () => {
      await this.storageService.waitUntilReady();
      this.setup();
    });

    this.router.events.subscribe(async (event) => {
      if (event instanceof NavigationStart) {
        // Clear error messages when navigation starts
        this.clearErrorMessage();
      }
    });

    // Subscribe to menu visibility state from service so app-level menu responds consistently
    this.menuVisibility.state$.subscribe((s) => {
      this.showMenu = s.showMenu;
      console.log(`[AppComponent] URL: ${s.normalizedUrl}, isNonMenu: ${!s.showMenu}, ShowMenu: ${this.showMenu}`);
    });

    // Wait until AuthService initialization completes before using needsPlan to avoid flicker
    this.authService.initialized.subscribe((isInit) => {
      if (!isInit) return;
      // Ensure we have fetched the canonical user state before deciding if the user needs a plan.
      (async () => {
        try {
          await this.authService.getUser();
        } catch (e) {
          // ignore; getUser already logs and handles logout on failure
        }

        // Now subscribe to needsPlan changes
        this.authService.needsPlan$.subscribe((needs) => {
          try {
            if (needs) {
              if (!this.authService.authState.getValue()) {
                return;
              }

              const url = this.router.url || '';
              // Avoid redirect loops and non-menu routes
              const isOnNonMenu = this.menuVisibility.isNonMenu(url);
              if (!isOnNonMenu && url !== '/register-existing-user') {
                this.router.navigate(['/register-existing-user']);
              }
            }
          } catch (e) {
            console.warn('Failed to navigate to register-existing-user', e);
          }
        });
      })();
    });

    // NOTE: Do not hide the top-level menu based on pending invite state here.
    // Menu visibility is controlled solely by route (login/register etc.).

    this.errorService.error$.subscribe((error) => {
      if (error) {
        this.errorMessage = error.message;        
        this.errorLogId = error.logId;
        if (error.code !== undefined) {
          this.errorCode = error.code;
        } 
      } else {
        this.errorMessage = null;
        this.errorLogId = null;
        this.errorCode = null;
      }
    });
  }

  


  /**
   * Setup
   */
  async setup() {
    if (!environment.mobile) {
      //this.injectSDK();
      //this.splashScreen.hide();
    }

    //this.statusBar.backgroundColorByHexString('#ff9e00');
    //this.getUserLatestData();
    //this.registerDevice();
    //this.googleStore.registerProducts();
    //await this.admob.initialize();

    if (environment.mobile) {
      //this.splashScreen.hide();
    }
  }


  clearErrorMessage() {
    this.errorService.clearError();
  }
}
